var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    { staticClass: "no-padding", attrs: { name: "time-tracking" } },
    [
      _c(
        "div",
        { staticClass: "layout-padding" },
        [
          _c(
            "div",
            { staticClass: "row justify-end q-mb-sm-none q-mb-md" },
            [
              _c(
                "q-btn",
                {
                  staticClass: "q-mr-md",
                  attrs: {
                    icon: "save",
                    flat: "",
                    disable: !_vm.hasTimeEntries
                  },
                  on: { click: _vm.handleExportTimeReport }
                },
                [
                  _c("q-tooltip", [_vm._v(_vm._s(_vm.$t("export_timereport")))])
                ],
                1
              ),
              _c(
                "q-btn",
                { attrs: { flat: "" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.dateRangeHumanReadable) +
                      "\n        "
                  ),
                  _c("time-range-popover", {
                    model: {
                      value: _vm.range,
                      callback: function($$v) {
                        _vm.range = $$v
                      },
                      expression: "range"
                    }
                  })
                ],
                1
              ),
              _c(
                "q-btn",
                {
                  staticClass: "q-mr-md",
                  attrs: {
                    label: _vm.$t("filter"),
                    icon: "filter_list",
                    flat: ""
                  }
                },
                [
                  _vm.filterCount > 0
                    ? _c(
                        "q-chip",
                        { attrs: { color: "primary", floating: "" } },
                        [_vm._v(_vm._s(_vm.filterCount))]
                      )
                    : _vm._e(),
                  _c(
                    "q-popover",
                    [
                      _c(
                        "q-list",
                        { attrs: { separator: "", link: "" } },
                        [
                          _c(
                            "q-item",
                            [
                              _c("q-item-side", {
                                attrs: { icon: "attach_money" }
                              }),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-select", {
                                    attrs: {
                                      options: _vm.billedFilterOptions,
                                      placeholder: _vm.$t(
                                        "time_tracking_filter_billed"
                                      ),
                                      "hide-underline": "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.filter.billed,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "billed", $$v)
                                      },
                                      expression: "filter.billed"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("q-select", {
                staticClass: "project__mode-dropdown",
                attrs: {
                  "hide-underline": "",
                  "inverted-light": "",
                  color: "white",
                  options: _vm.listModes,
                  value: _vm.listMode
                },
                on: { change: _vm.handleListModeChanged }
              })
            ],
            1
          ),
          _c(
            "q-infinite-scroll",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasTimeEntries,
                  expression: "hasTimeEntries"
                }
              ],
              ref: "infiniteScroll",
              attrs: { handler: _vm.handleFetchNextChunk }
            },
            [
              _c("time-entries-list", {
                attrs: {
                  "time-entries": _vm.timeEntries,
                  showUser: _vm.showAllEntries
                }
              })
            ],
            1
          ),
          !_vm.hasTimeEntries
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-center items-center col-grow q-mt-xl"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c("img", {
                          attrs: {
                            src: require("assets/emptystates/time_entries_empty.svg")
                          }
                        }),
                        _c("h6", { staticClass: "q-my-md text-faded" }, [
                          _vm._v(_vm._s(_vm.$t("no_time_entries")))
                        ]),
                        _c("q-btn", {
                          attrs: {
                            outline: "",
                            color: "primary",
                            label: _vm.$t("start_time_entry")
                          },
                          on: { click: _vm.handleStartTimeEntry }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }